import { render, staticRenderFns } from "./firstPart.vue?vue&type=template&id=00cebe13"
import script from "./firstPart.vue?vue&type=script&lang=js"
export * from "./firstPart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports